<div class="splitter-container" #container [ngClass]="direction">
  <!-- FIRST PANEL -->
  <div class="panel first" [ngStyle]="direction === 'horizontal' ? {'width.px': size} : {'height.px': size}">
    <!-- Collapse button -->
    <button class="toggle-btn" (click)="toggle()">
      {{ direction === 'horizontal'
    ? (collapsed ? '▶' : '◀')
    : (collapsed ? '▼' : '▲') }}
    </button>

    <ng-content select="[first]"></ng-content>
  </div>

  <!-- Divider -->
  <div class="divider" (mousedown)="startDrag($event)"></div>

  <!-- SECOND PANEL -->
  <div class="panel second">
    <ng-content select="[second]"></ng-content>
  </div>
</div>